import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M10.628 9.552c-.428.327-.863.643-1.275.987-.102.085-.152.26-.178.402-.15.816-.283 1.634-.425 2.45-.089.514-.355.732-.78.65-.372-.073-.543-.4-.47-.873.158-1.004.292-2.01.474-3.01.044-.244.182-.518.364-.683.703-.637 1.45-1.226 2.164-1.852.679-.598 1.475-.588 2.25-.374.298.082.575.46.736.767.431.824.78 1.69 1.192 2.524.096.194.28.383.472.485.687.366 1.399.684 2.09 1.041.187.097.398.237.485.413.084.168.092.447.003.606-.073.134-.33.217-.511.226-.192.01-.395-.078-.58-.152-.33-.132-.652-.286-.975-.434-.903-.413-1.89-.712-2.3-1.791l-.139.036c-.17.777-.352 1.552-.499 2.333-.022.12.104.277.182.404 1.105 1.807 2.217 3.61 3.315 5.42.156.257.298.538.366.827.087.366 0 .706-.386.902-.377.19-.739.175-1.025-.133a8 8 0 0 1-.817-1.034c-1.26-1.928-2.496-3.873-3.759-5.8-.406-.62-.533-1.259-.36-1.98.182-.754.324-1.516.483-2.274z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M9.874 14.446c.417.572.793 1.073 1.146 1.589.073.106.115.289.077.405-.143.432-.254.9-.508 1.265a51 51 0 0 1-2.206 2.913c-.36.444-.776.479-1.111.219-.323-.25-.37-.679-.08-1.146.295-.474.594-.952.948-1.382.806-.977 1.278-2.098 1.55-3.318.026-.115.064-.228.099-.341.014-.045.036-.086.085-.204M13.35 6.423c-.965-.003-1.707-.733-1.714-1.687A1.7 1.7 0 0 1 13.364 3a1.7 1.7 0 0 1 1.714 1.749c-.013.954-.758 1.676-1.727 1.674"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }